var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy211211(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CDD8C9",
    d: "M64.7,22.3c-6.3,0-11.8,3.2-15.1,8c-3.3-4.8-8.8-8-15.1-8c-10.1,0-18.2,8.1-18.2,18.2c0,5.4,2.6,10.1,6,13.5 c3.5,3.5,10.1,10.4,15.9,16.3c2.9,3,5.5,5.7,7.5,7.8c1,1,1.8,1.8,2.3,2.4s0.8,0.9,0.8,0.9c0.2,0.2,0.5,0.3,0.7,0.3c0,0,0,0,0,0 c0.1,0,0.2,0,0.3-0.1c0,0,0,0,0,0c0.2-0.1,0.3-0.1,0.4-0.2c0,0,0.3-0.3,0.8-0.9c3.8-4,19.5-20.3,25.6-26.5c3.5-3.5,6-8.1,6-13.5 C82.9,30.5,74.7,22.3,64.7,22.3z M75.4,52.6c-6.3,6.3-22.3,23-25.8,26.7c-3.5-3.7-19.5-20.4-25.8-26.7c-3.2-3.2-5.4-7.3-5.4-12.1 c0-4.5,1.8-8.5,4.7-11.5c2.9-2.9,7-4.7,11.5-4.7c6.1,0,11.4,3.4,14.2,8.4c0.2,0.3,0.5,0.5,0.9,0.5c0,0,0,0,0,0c0,0,0,0,0,0 c0.4,0,0.7-0.2,0.9-0.5c2.8-5,8.1-8.4,14.2-8.4c4.5,0,8.5,1.8,11.5,4.7c2.9,2.9,4.7,7,4.7,11.5C80.9,45.3,78.6,49.4,75.4,52.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy211211);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-211-211.2bd751e736051f48fc49674576ac3b29.svg";
export { ForwardRef as ReactComponent };